import type { ReactNode } from "react";
import { PanelBackHeading } from "../PanelBackHeading";
import { ChatpadBody, ChatpadList, ChatpadListHeader } from "./ChatpadList";

export function ChatpadPreview({
  title,
  backLabel,
  onBack,
  actions,
  children,
}: {
  title: string;
  backLabel: string;
  onBack: () => void;
  actions?: ReactNode;
  children: ReactNode;
}) {
  return (
    <ChatpadBody data-fill="true">
      <ChatpadList role="region" aria-label="Preview" data-fill="true">
        <ChatpadListHeader>
          <PanelBackHeading
            title={title}
            backLabel={backLabel}
            onBack={onBack}
          />
          {actions}
        </ChatpadListHeader>
        <div style={{ display: "flex", flex: 1, minHeight: 0 }}>{children}</div>
      </ChatpadList>
    </ChatpadBody>
  );
}
